<template>
  <router-view v-if="!isSignedIn" />
</template>

<script>
export default {
  name: 'automation',

  routerViewMeta: {
    title: 'Automation',
    $hide: [ 'header', 'footer' ]
  },

  mounted() {
    this.$router.replace({ name: this.isSignedIn ? 'account-automations' : 'automation-new' });
  }
}
</script>